import { render } from "./ReporteECP.vue?vue&type=template&id=70875670&scoped=true"
import script from "./ReporteECP.vue?vue&type=script&lang=js"
export * from "./ReporteECP.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ReporteECP.vue?vue&type=style&index=1&id=70875670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70875670"]])

export default __exports__